import { FormField } from '../../../../types';
import { FormFieldRow } from '../components/FormSection.types';

/** Pair only adjacent numeric fields; never reorder fields across another input. */
export const groupNumericFields = (fields: FormField[]): FormFieldRow[] => {
  const rows: FormFieldRow[] = [];

  for (let index = 0; index < fields.length; index += 1) {
    const field = fields[index];
    const nextField = fields[index + 1];
    const isNumeric = field.type === 'number';

    if (isNumeric && nextField?.type === 'number') {
      rows.push({ fields: [field, nextField], isNumeric: true });
      index += 1;
    } else {
      rows.push({ fields: [field], isNumeric });
    }
  }

  return rows;
};
